<script setup>
// Kutuphane bolumunun kabugu: kreatif, medya, form ve rakip reklamlarini
// tek baslik altinda toplar.
//
// Bu dort sekme ayri menu maddesi olsaydi kenar cubugu sisecekti; hepsi ayni
// "reklamda kullanilan varliklar" isine hizmet ettigi icin tek bolum.
//
// Katalog buradan CIKARILDI: urun katalogu artik Meta'ya bagimli olmayan
// kendi bolumu (Katalog). Reklam varliklarinin yaninda durmasi, katalogun
// yalnizca reklam icin oldugu izlenimi veriyordu.
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import MetaAdsKabuk from './MetaAdsKabuk.vue';

const { t } = useI18n();

// Sekme adlari dil degisiminde guncellensin diye computed; sabit dizi olsaydi
// kullanici dili degistirdiginde eski metinler ekranda kalirdi.
const sekmeler = computed(() => [
  { ad: t('META_ADS.KUTUPHANE.SEKME.KREATIFLER'), rota: 'meta_ads_kreatifler' },
  { ad: t('META_ADS.KUTUPHANE.SEKME.MEDYA'), rota: 'meta_ads_medya' },
  { ad: t('META_ADS.KUTUPHANE.SEKME.FORMLAR'), rota: 'meta_ads_formlar' },
  {
    ad: t('META_ADS.KUTUPHANE.SEKME.REKLAM_KUTUPHANESI'),
    rota: 'meta_ads_reklam_kutuphanesi',
  },
]);
</script>

<template>
  <!--
    hesapGerekli acik: dort sekmenin ucu reklam hesabina bagli veri cekiyor.
    Reklam Kutuphanesi sekmesi hesaptan bagimsiz calissa da secici ust bantta
    durmasi kullaniciyi sasirtmaz, bolumler arasi gecerken secim korunur.
  -->
  <MetaAdsKabuk
    :baslik="t('META_ADS.KUTUPHANE.BASLIK')"
    :sekmeler="sekmeler"
    :hesap-gerekli="true"
  />
</template>
